import { render, staticRenderFns } from "./PaymentCompleted.vue?vue&type=template&id=699094b7&scoped=true"
import script from "./PaymentCompleted.vue?vue&type=script&lang=js"
export * from "./PaymentCompleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699094b7",
  null
  
)

export default component.exports